import { render } from "./AvatarFoto.vue?vue&type=template&id=37d7404e&scoped=true"
import script from "./AvatarFoto.vue?vue&type=script&lang=js"
export * from "./AvatarFoto.vue?vue&type=script&lang=js"

import "./AvatarFoto.vue?vue&type=style&index=0&id=37d7404e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d7404e"]])

export default __exports__